const TEST_GROUP_NAMES = ['/test'];

export default TEST_GROUP_NAMES;
